import { styled } from '@mui/material';

export const CloseButtonStyled = styled('button')<{
  isFullscreen: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 30px;
  height: 30px;
  z-index: 3;
  top: ${({ isFullscreen }) => (!isFullscreen ? '15px' : '68px')};
  right: ${({ isFullscreen }) => (!isFullscreen ? '15px' : '18px')};
  border-radius: 50%;
  background-color: var(--color-primary);

  cursor: pointer;

  svg,
  i {
    color: #fff;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  &:hover {
    svg,
    i {
      color: var(--color-secondary);
    }
  }

  @media screen and (max-width: 425px) and (orientation: portrait) {
    right: ${({ isFullscreen }) => (!isFullscreen ? '-15px' : '18px')};
  }
`;
